import getScript from 'lib/utils/getScript'

export default function setupGoogle() {
  getScript('https://accounts.google.com/gsi/client?onload=initClient')
}
